import { motion } from 'framer-motion';
import { ClockIcon, MegaphoneIcon   } from '@heroicons/react/24/outline';

const NewsSection = () => {

  return (
    <div className="py-16 bg-primary/10">
      <div className="container mx-auto px-4">
        <motion.div 
          className="bg-white rounded-2xl shadow-elegant overflow-hidden"
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <div className="flex flex-col lg:flex-row">
            {/* Left side - Illustration */}
            <div className="lg:w-1/3 bg-primary p-8 flex items-center justify-center">
              {/* Top section - Icon and text */}
              <div className="text-center">
                <MegaphoneIcon className="h-24 w-24 mx-auto text-white mb-4" />
                <h1 className="text-white text-5xl font-bold">NOUVEAUTE !</h1>
              </div>
            </div>
            
            {/* Right side - Information */}
            <div className="lg:w-2/3 p-8 md:p-12">
              <div className="mb-6">
                <div className="flex items-center gap-4 mb-6">
                  <ClockIcon className="h-16 w-16 text-primary flex-shrink-0" />
                  <div>
                    <h1 className="text-gray-900 text-4xl font-bold">Horaire Continu</h1>
                    <h1 className="text-gray-900 text-4xl font-bold">التوقيت المستمر</h1>
                  </div>
                </div>
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">من الروض الى اللإعدادي </h3>
                <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">De la maternelle au collège</h3>
              </div>

              <div className="text-gray-700 bg-white p-4 rounded-lg border-l-4 border-primary">
                <p className="text-sm">
                  Pour plus d'informations sur l'horaire continu, veuillez contacter l'administration de l'école ou consulter la page de contact.
                </p>
              </div>
            </div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default NewsSection;